import React, { useMemo } from 'react';
import { Button } from '@pinwheel/origami';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../state';
import { selectIncomeSources, setIncomeSource1099, } from '../../state/slices/slice-wizard';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import BaseWizardScreen from './BaseWizardScreen';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
export default function WizardIncomeSource1099() {
    var incomeSources = useAppSelector(selectIncomeSources);
    var navigate = useLinkNavigate();
    var dispatch = useDispatch();
    var getLocalizedString = useGetLocalizedString();
    var determineRoute = useMemo(function () {
        if (incomeSources.incomeSources.find(function (is) { return is === 'benefits'; })) {
            return '/wizard/income-source-benefits';
        }
        return '/search/search';
    }, [incomeSources]);
    var buttons = useMemo(function () { return (React.createElement("div", null,
        React.createElement(Button, { dataTestId: "Yes", onClick: function () {
                dispatch(setIncomeSource1099({ visited: true, primaryIncomeSource: true }));
                return navigate(determineRoute);
            } }, getLocalizedString('YES')),
        React.createElement(Button, { dataTestId: "No", variant: "outline", onClick: function () {
                dispatch(setIncomeSource1099({ visited: true, primaryIncomeSource: false }));
                return navigate(determineRoute);
            } }, getLocalizedString('NO')))); }, [determineRoute, getLocalizedString, navigate, dispatch]);
    return (React.createElement(BaseWizardScreen, { dataTestId: "Wizard-IncomeSource1099", titleText: getLocalizedString('WIZARD_INCOME_SOURCE_1099'), buttons: buttons }));
}
